<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import { onDestroy } from 'svelte';
	import { writable } from 'svelte/store';
	import EmGenerationChart from 'src/components/EnergyMonitoring/sections/EmGenerationChart.svelte';
	import { createEnergyMonitoringStatsLoader } from 'src/components/EnergyMonitoring/helpers/energy_monitoring_stats_loader';
	import { emptyEnergyMonitoringStats } from 'src/components/EnergyMonitoring/helpers/store';
	import { buildDemoEnergyMonitoringStats } from 'src/components/EnergyMonitoring/helpers/energy_demo_providers';
	import { energyV2Actions } from 'src/components/EnergyMonitoring/v2/energy-v2-ui';
	import { buildEnergyRangeControls } from 'src/components/EnergyMonitoring/helpers/period_helpers';
	import { getEnergyConfigForType } from 'src/components/Dashboards/dash-energy-helpers';
	import { Container } from '@Shelly/shelly-design-system';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';
	import { currentUnitId } from 'src/stores/account/home';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let useEnergyPageContext = false;
	export let staticPreview = false;

	const widgetStats = writable(emptyEnergyMonitoringStats());
	const statsLoader = createEnergyMonitoringStatsLoader(widgetStats);

	$: config = getEnergyConfigForType('dashEnergyGeneration', energyConfig);
	$: controls = buildEnergyRangeControls(config.period);
	$: if (staticPreview) widgetStats.set(buildDemoEnergyMonitoringStats());
	else {
		$currentUnitId;
		statsLoader.load(controls, config.period);
	}
	$: requirePvSetup = useEnergyPageContext && $energyV2Actions?.activePurpose === 'pv';

	onDestroy(() => statsLoader.destroy());
</script>

<Container type="glass" noScroll fullHeight>
	<EmGenerationChart embedded statsStore={widgetStats} {requirePvSetup} />
</Container>
